import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { BuildingId, OrgId } from 'app/common/types/id'
import { api } from 'app/api'

import {
  GET_SALE_POINTS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/sale_points/get'

import { orgsFilterSelection } from './orgsFilter'
import { buildingsFilterSelection } from './buildingsFilter'

type SalePoints = Array<ItemType>

class SalePointsFilterDataBox extends DataBox<SalePoints> {}

export const defaultSalePoints: SalePoints = []
export const salePointsFilter = createDataBox(
  'salePointsFilter',
  defaultSalePoints,
  SalePointsFilterDataBox,
)

export const defaultSalePointsDataReceiver = async () => {
  const buildingIds = buildingsFilterSelection.getData() || [null]
  const buildingId = buildingIds[0]

  const orgIds = orgsFilterSelection.getData() || [null]
  const orgId = orgIds[0]
  if (!orgId) return []

  const res = await api.request(GET_SALE_POINTS, {
    error: 'Не удалось получить данные точек продаж',
    params: {
      orgId: orgId as OrgId,
      buildingId: buildingId as BuildingId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res?.filter(({ deleted }) => !deleted) || []
}

salePointsFilter.addDataReceiver(defaultSalePointsDataReceiver)

export const defaultSalePointsSelection: Array<string> = []
export const salePointsFilterSelection = createDataBoxDefault<Array<string>>(
  'salePointsFilterSelection',
  defaultSalePointsSelection,
)
